import { FunctionComponent } from 'src/common/types/react';

import { CardContainer } from './styles';

export default function AuthCard({ children }: FunctionComponent) {
    return <CardContainer>{children}</CardContainer>;
}
